import { useTranslation } from 'react-i18next'

import { EMPTY_FUNCTION } from '../../../constants/common'
import Button, { BUTTON_HEIGHT_16 } from '../../Button'
import { EMPTY_SEARCH_VALUE } from '../Search.constants'
import { isValidSearchValue } from '../Search.utils'

import * as styles from './SearchButton.module.css'

import SearchIcon from '../../../icons/search.svg'

/**
 * @typedef {object} SearchButtonProps
 *
 * @property {React.ComponentType<SVGProps>} [Icon]
 *
 * @property {number} [height]
 *
 * @property {string} [tooltip]
 *
 * @property {SearchValue} [search]
 *
 * @property {(search: SearchValue) => void} [onSearch]
 */

/**
 * @param {SearchButtonProps} props
 */
function SearchButton({
  Icon = SearchIcon,
  checkValueForSearch = isValidSearchValue,
  height = BUTTON_HEIGHT_16,
  search = EMPTY_SEARCH_VALUE,
  tooltip = 'Header.SearchBtnKey',
  onSearch = EMPTY_FUNCTION,
  ...buttonProps
}) {
  const { t } = useTranslation()

  function handleClick() {
    onSearch(search)
  }

  return (
    <Button.Text
      {...buttonProps}
      isGrey
      beforeIconProps={{ Icon }}
      className={styles.SearchButton}
      disabled={!checkValueForSearch(search)}
      height={height}
      tooltip={t(tooltip)}
      onClick={handleClick}
    />
  )
}

export default SearchButton
